import { FC } from 'react'
import createStandardIcon from './createStandardIcon'
import type { IconProps } from './type'

const FileQuestionIconSvg: FC<IconProps> = (props) => {
  const { fill, stroke, ...rest } = props
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 22" fill="none" {...rest}>
      <path
        d="M9.59922 20.6H3.59921C2.27372 20.6 1.19921 19.5254 1.19922 18.2L1.19931 3.80001C1.19932 2.47453 2.27383 1.40002 3.59931 1.40002H14.3996C15.7251 1.40002 16.7996 2.47454 16.7996 3.80002V8.00002M11.9996 14.5479C11.9996 13.2512 13.0741 12.2 14.3996 12.2C15.7251 12.2 16.7996 13.2512 16.7996 14.5479C16.7996 15.8446 15.7251 16.8958 14.3996 16.8958M14.3996 20.0903V20"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const FileQuestionIcon = createStandardIcon(FileQuestionIconSvg)
